var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.515155,
    y: 5.82375,
    width: 33.9697,
    height: 24.8005,
    rx: 2.91921,
    stroke: "#0A0B0C",
    strokeWidth: 1.03031
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1553 5.82422V18.8584C31.1553 20.4705 29.8484 21.7781 28.2363 21.7783H6.77148C5.15925 21.7783 3.85254 20.4706 3.85254 18.8584V5.82422H31.1553Z",
    stroke: "#0A0B0C",
    strokeWidth: 1.03031
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4832 21.7461V24.9619H15.5144V21.7461H19.4832Z",
    stroke: "#0A0B0C",
    strokeWidth: 1.03031
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1018 0.515625H20.2327C21.8449 0.515625 23.1516 1.82233 23.1516 3.43457V5.85449H11.1829V3.43457C11.1829 1.82233 12.4896 0.515625 14.1018 0.515625Z",
    stroke: "black",
    strokeWidth: 1.03031
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessIcon);
export default __webpack_public_path__ + "static/media/businessIcon.b01b8577bcaf5afe2fb355e5c0f72b2f.svg";
export { ForwardRef as ReactComponent };